import { Container } from '@mui/material';
import ManagementSettings from 'src/features/settings';

const ManagementSettingsPage = () => {
  return (
    <Container maxWidth={false}>
      <ManagementSettings />
    </Container>
  );
};

export default ManagementSettingsPage;
